import React from "react";

import { Button, IconPlus, Label } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

type Props = {
  onAddAddressClick: () => void;
};

export const EmptyBillingAddress: React.FC<Props> = ({ onAddAddressClick }) => {
  const { translator } = useAppContext();

  return (
    <div className="flex flex-col justify-between gap-200 sm:flex-row sm:gap-100">
      <div className="flex flex-col gap-100">
        <Label as="span" size="lg" fontWeight="bold">
          {translator.t("!accounts.settings.billing-information")}
        </Label>
        <Label size="md" as="span" className="text-color-secondary">
          {translator.t("!accounts.settings.save-billing-address-description")}
        </Label>
      </div>
      <Button
        iconStart={<IconPlus size="md" />}
        size="lg"
        onClick={() => {
          onAddAddressClick();
        }}
      >
        {translator.t("!accounts.settings.add-address")}
      </Button>
    </div>
  );
};
